export const IDENTITY = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
export const IDENTITY_3X3 = [1, 0, 0, 0, 1, 0, 0, 0, 1];

export const EPSILON = 1e-6;
export const VTK_SMALL_NUMBER = 1.0e-12;

export default {
  IDENTITY,
  IDENTITY_3X3,
  EPSILON,
  VTK_SMALL_NUMBER,
};
